
import { NewsLetterError } from '@/exceptions/news_letter/news.enum';
import { newsLetterService } from '@/services/news_letter.service';
import { notificationService } from '@/services/notification.service';
import { useMutation, useQueryClient } from '@tanstack/react-query';

const useUpdateNewsLetter = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async ([newsLetterId, newsLetter]: [number, FormData]) =>
            await newsLetterService.editNewsLetter(newsLetterId, newsLetter),

        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['newsLetter'] });
            notificationService.success("newsLetter Updated Succesful");

        },

        onError: () => {
            throw new Error(NewsLetterError.EDIT_ERROR);
        },
    });
};

export default useUpdateNewsLetter;
